import styled from "@emotion/styled";
// import { colors } from '@atlaskit/theme';
import type { DragStart, DraggableLocation, DropResult, DroppableProvided } from "@hello-pangea/dnd";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import React, { Component, ReactElement } from "react";

// import { PartialAutoScrollerOptions } from '../../../src/state/auto-scroller/fluid-scroller/auto-scroller-options-types';

import { QuestsModel, WorkflowsJourney } from "../../../Models/Quests/Quests.Model";
import AddJourneyButton from "./Journeys/Components/AddJourneyButton";
import JourneyColumn from "./Journeys/JourneyColumn";

interface ParentContainerProps {
  height: string;
}

const Container = styled.div`
  background-color: #f5f5f5;
  min-height: 100vh;
  /* like display:flex but will allow bleeding over the window width */
  min-width: 100vw;
  display: inline-flex;
`;

interface Props {
  workflowJournys: WorkflowsJourney[];
  withScrollableColumns?: boolean;
  isCombineEnabled?: boolean;
  containerHeight?: string;
  applyGlobalStyles?: boolean;
  autoScrollerOptions?: any;
  isSearching: boolean;
}

interface State {
  isDraggingAQuest: boolean;
  // columns: WorkflowsJourney[];
  // ordered: string[];
}

export default class Board extends Component<Props, State> {
  /* eslint-disable react/sort-comp */
  static defaultProps = {
    isCombineEnabled: false,
    applyGlobalStyles: true,
  };

  state: State = {
    isDraggingAQuest: false,
    // columns: this.props.initial,
  };
  onBeforeDragStart = (data: DragStart): void => {
    if (data.type === "QUEST") {
      this.setState({
        isDraggingAQuest: true,
      });
    }
  };

  onDragEnd = (result: DropResult): void => {
    if (result.type === "QUEST") {
      this.setState({
        isDraggingAQuest: false,
      });
    }
    /*
    if (result.combine) {
      if (result.type === 'COLUMN') {
        const shallow: string[] = [...this.state.ordered];
        shallow.splice(result.source.index, 1);
        this.setState({ ordered: shallow });
        return;
      }

      const column: QuestInterface[] = this.state.columns[result.source.droppableId];
      const withQuoteRemoved: QuestInterface[] = [...column];
      withQuoteRemoved.splice(result.source.index, 1);
      const columns: Jouen = {
        ...this.state.columns,
        [result.source.droppableId]: withQuoteRemoved,
      };
      this.setState({ columns });
      return;
    }
    */
    // dropped nowhere
    if (!result.destination) {
      return;
    }

    const source: DraggableLocation = result.source;
    const destination: DraggableLocation = result.destination;

    // did not move anywhere - can bail early
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return;
    }

    // reordering column
    if (result.type === "COLUMN") {
      QuestsModel.reorderWorkflow(source.index, destination.index);

      // const ordered: string[] = reorder(
      //   this.props.workflowJournys,
      //   source.index,
      //   destination.index,
      // );

      // this.setState({
      //   ordered,
      // });

      return;
    }
    QuestsModel.reorderQuestInJourneys(source, destination);

    // const data = reorderQuoteMap({
    //   quoteMap: this.state.columns,
    //   source,
    //   destination,
    // });

    // this.setState({
    //   columns: data.quoteMap,
    // });
  };

  render(): ReactElement {
    // const columns: WorkflowsJourney[] = this.state.columns;
    //
    // const ordered: string[] = this.state.ordered;
    const { containerHeight, isCombineEnabled, withScrollableColumns, applyGlobalStyles, workflowJournys } = this.props;

    const board = (
      <Droppable droppableId="board" type="COLUMN" direction="horizontal" ignoreContainerClipping={Boolean(containerHeight)} isCombineEnabled={false}>
        {(provided: DroppableProvided) => (
          <Container ref={provided.innerRef} {...provided.droppableProps}>
            <AddJourneyButton />

            {workflowJournys.map((item: WorkflowsJourney, index) => {
              //
              return (
                <JourneyColumn
                  key={item.isUnassignedGroup ? "unassigned" : item.journey?.slug}
                  index={index}
                  title={item.isUnassignedGroup ? "unassigned" : item.journey?.name || ""}
                  workflowJourney={item}
                  isScrollable={withScrollableColumns}
                  isCombineEnabled={isCombineEnabled}
                  isDraggingAQuest={this.state.isDraggingAQuest}
                />
              );
            })}
            {provided.placeholder}
          </Container>
        )}
      </Droppable>
    );

    return (
      <React.Fragment>
        <DragDropContext onBeforeDragStart={this.onBeforeDragStart} onDragEnd={this.onDragEnd} autoScrollerOptions={this.props.autoScrollerOptions}>
          {board}
        </DragDropContext>
      </React.Fragment>
    );
  }
}
